import { Taskable } from './taskable.js';

let TaskGroup$1 = class TaskGroup extends Taskable {};

export { TaskGroup$1 as TaskGroup };
//# sourceMappingURL=task-group.js.map
